<template>
    <div>

        <!-- Desktop Tabs -->
        <div class="activity-header">
            <span
                v-for="tab in tabs"
                :key="`activity-feed-tab-${tab.key}`"
                :id="`activity-feed-${tab.key}`"
                :class="{'active' : currentTab == tab.key }"
                :data-id="tab.key"
                @click="setCurrentTab(tab)">
                {{ tab.label }}
                <small v-if="currentItems[tab.key].total" v-text="currentItems[tab.key].total"></small>
            </span>
        </div>

        <!-- Mobile Dropdown Filters -->
        <div class="activity-header-mob">
            <h2>
                <span id="mob-activity-title" v-text="mobileSelectedFilterText"></span>
                <small id="mob-activity-total" v-text="currentItems[currentTab].total"></small>
            </h2>

            <span @click="toggleMobileFilters = !toggleMobileFilters" class="activity-filter-trigger">
                Filter
                <svg class="filter"><use xlink:href="#filter"></use></svg>
            </span>

            <div v-if="toggleMobileFilters" @focusout="showMobileFilters = !showMobileFilters" class="activity-filter-dd">
                <div class="activity-filter-dd-shade"></div>
                <div class="activity-filter-dd-inner">
                    <h2>
                        Filter By:

                        <span @click="toggleMobileFilters = !toggleMobileFilters"
                              class="activity-filter-dd-close">
                            <svg class="close"> <use xlink:href="#close"></use></svg>
                        </span>
                    </h2>

                    <span v-for="tab in tabs" :class="{'active' : tab.key == currentTab }"
                          :key="`activity-feed-mobile-tab-${tab.key}`"
                          @click="setCurrentTab(tab)">

                        {{ tab.label }}
                        <small v-if="currentItems[tab.key].total" v-text="currentItems[tab.key].total"></small>
                    </span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    export default {

        props: ['tabs', 'items', 'value'],

        data() {
            return {
                currentItems: this.items,
                currentTab: this.value,
                toggleMobileFilters: false,
            }
        },

        methods: {
            setCurrentTab(tab) {
                this.currentTab = tab.key
                this.$emit('input', this.currentTab)
                this.toggleMobileFilters = false
            }
        },

        watch: {
            items() {
                console.log('updated')
                this.currentItems = this.items
            }
        },

        computed: {
            mobileSelectedFilterText() {
                if (this.currentTab == 'all') {
                    return 'Activity Feed';
                }
                return _.find(this.tabs, t => t.key == this.currentTab).label
            }
        }
    }
</script>
